import Button from "@app/components/button";
import { FormControl } from "@app/components/form-control";
import Input from "@app/components/input";
import Facebook from "@app/icons/facebook";
import { LoginRequest } from "@app/types";
import { loginValidationSchema } from "@app/validations";
import { Images } from "@assets/images";
import { CredentialResponse, GoogleLogin } from "@react-oauth/google";
import { Form, Formik, FormikContextType } from "formik";
import { createRef } from "react";
import { addToast } from "../toast/toast.service";
import { SystemMessage } from "@app/constants";
import FacebookLogin from "react-facebook-login/dist/facebook-login-render-props";
import {
  ReactFacebookFailureResponse,
  ReactFacebookLoginInfo,
} from "react-facebook-login";
import { Environment } from "@environments/environment";

interface SignInProps {
  onSwitchToSignUp: () => void;
  onSwitchToForgotPassword: () => void;
  onSubmit: (values: LoginRequest) => void;
  onGoogleLoginSuccess: (credentialResponse: CredentialResponse) => void;
  onFacebookLoginSuccess: (
    userInfo: ReactFacebookLoginInfo | ReactFacebookFailureResponse
  ) => void;
}

function SignIn({
  onSwitchToSignUp,
  onSwitchToForgotPassword,
  onSubmit,
  onGoogleLoginSuccess,
  onFacebookLoginSuccess,
}: SignInProps) {
  const formRef = createRef<FormikContextType<LoginRequest>>();

  const onGoogleLoginError = () => {
    addToast({ text: SystemMessage.LOGIN_FAILED, status: "inValid" });
  };

  return (
    <div className="flex items-center justify-center">
      <div className="w-[443px] h-auto px-[34px] py-10 bg-white rounded-xl">
        <div className="flex justify-center">
          <img className="w-28" src={Images.LogoText.default} alt="" />
        </div>
        <div className="mt-6 font-semibold text-xl text-center neutral-n80 font-[SVN-Gilroy]">
          Chào mừng trở lại!
        </div>
        <div className="mt-2 black-30 text-sm text-center black-30 font-[SVN-Gilroy] font-medium">
          Đăng nhập vào tài khoản của bạn
        </div>
        <Formik
          innerRef={formRef}
          initialValues={{ email: "", password: "" }}
          onSubmit={onSubmit}
          validationSchema={loginValidationSchema}
          validateOnBlur
          validateOnChange
        >
          <Form>
            <div className="mt-[60px]">
              <FormControl name="email">
                <Input
                  inputIcon={Images.MessageIcon.default}
                  inputIconClassName="!w-[18px] !h-[18px]"
                  inputClassName="font-[SVN-Gilroy] font-medium !text-[#272C36] tracking-[0.024px]"
                  errorClassName="font-[SVN-Gilroy] tracking-[0.024px]"
                />
              </FormControl>
            </div>
            <div className="mt-3">
              <FormControl name="password">
                <Input
                  type="password"
                  inputIcon={Images.SecurityIcon.default}
                  inputIconClassName="!w-[18px] !h-[18px]"
                  inputClassName="font-[SVN-Gilroy] font-medium !text-[#272C36] tracking-[0.024px]"
                  errorClassName="font-[SVN-Gilroy] tracking-[0.024px]"
                />
              </FormControl>
            </div>
            <div className="primary-100 mt-3 text-sm text-end">
              <span onClick={onSwitchToForgotPassword} className="cursor-pointer text-[#38499b] font-[SVN-Gilroy]">
                Quên mật khẩu
              </span>
            </div>
            <Button
              type="submit"
              containerClassName="mt-10 mx-auto"
              label="Đăng nhập"
              labelClassName="font-[SVN-Gilroy]"
              width=""
              size="l"
              className="text-lg font-bold rounded-3xl"
            />
            <div className="flex items-center justify-center my-6 px-10">
              <hr className="flex-1 border-t border-gray-300" />
              <span className="mx-2 text-gray-500 text-sm font-[SVN-Gilroy]">
                Or continue with
              </span>
              <hr className="flex-1 border-t border-gray-300" />
            </div>
            <div className="flex space-x-4 my-6 justify-center items-center">
              <FacebookLogin
                appId={Environment.FACEBOOK_APP_ID}
                fields="name,email,picture"
                callback={onFacebookLoginSuccess}
                render={({ onClick }) => (
                  <button
                    type="button"
                    className="flex items-center justify-center space-x-2 px-4 py-2 h-10 border border-gray-300 rounded-full text-gray-700 hover:bg-gray-100 w-[141px]"
                    onClick={onClick}
                  >
                    <Facebook />
                    <span className="font-[SVN-Gilroy] font-semibold text-[14px]">
                      Facebook
                    </span>
                  </button>
                )}
              />
              <GoogleLogin
                onSuccess={onGoogleLoginSuccess}
                onError={onGoogleLoginError}
                shape="pill"
                theme="outline"
                size="large"
                text="signin"
                width={141}
              />
            </div>
            <div className="text-center mt-8 text-sm font-medium font-[SVN-Gilroy] text-[#333B47]">
              Chưa có tài khoản?{" "}
              <span
                className="text-[#5A82D7] cursor-pointer font-semibold font-[SVN-Gilroy]"
                onClick={onSwitchToSignUp}
              >
                Đăng ký ngay
              </span>
            </div>
          </Form>
        </Formik>
      </div>
    </div>
  );
}

export default SignIn;
